module.exports = __webpack_public_path__ + "img/astral-txt_19.4e83379c.svg";